export default Object.freeze({
  SLOT_BOOKING_AND_CHECKOUT: 'slot_booking_and_checkout',
  SLOT_BOOKING_ONLY: 'slot_booking_only',
  NONE: 'none',
});
